module.exports = __webpack_public_path__ + "media/images/new-ui-images/search-icon-d370519cb99b95ca98e79223d65dcb6c.svg";